<script setup lang="ts">
import { StudySettings } from '@/components/study_settings';
import { useStudyStore } from '@/stores/study';
const studyStore = useStudyStore();
</script>

<template>
    <div class="study-settings-container" v-if="studyStore.selectedStudy">
        <StudySettings />
    </div>
</template>

<style scoped lang="scss">
.study-settings-container {
    height: 100%;
    overflow-y: scroll;
}
</style>
